import { Box, BoxProps } from '@chakra-ui/react'
import ImageLoad from './ImageLoad'

const PBoxCardImgComponent = ({
  pboxImg,
  treasureImg,
  treasureFallback,
  lightBg,
  loading = 'lazy',
  ...rest
}: {
  pboxImg?: string
  treasureImg: string
  treasureFallback?: string
  lightBg?: string
  loading?: 'lazy' | 'eager'
} & BoxProps) => {
  return (
    <Box position={'relative'} pointerEvents={'none'} {...rest}>
      <ImageLoad
        w="100%"
        mx="auto"
        maxW={'100%'}
        imageSrc={pboxImg}
        // aspectRatio={240 / 200}
        loading={loading}
      />

      {lightBg && (
        <ImageLoad
          imageSrc={lightBg}
          position={'absolute'}
          top={0}
          left={0}
          w={'100%'}
          className={'pbox-card_light'}
          // aspectRatio={240 / 155}
          loading={loading}
        />
      )}
      {treasureImg && (
        <ImageLoad
          position={'absolute'}
          top={0}
          left={0}
          w="100%"
          imageSrc={treasureImg}
          className={lightBg ? 'pbox-card_treasure' : 'pbox-card_treasure_scale'}
          fallback={treasureFallback}
          // aspectRatio={240 / 155}
          loading={loading}
        />
      )}
    </Box>
  )
}

export default PBoxCardImgComponent
